import { render, staticRenderFns } from "./TargetingBrowserLanguage.vue?vue&type=template&id=786f79f9&"
import script from "./TargetingBrowserLanguage.vue?vue&type=script&lang=js&"
export * from "./TargetingBrowserLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports